import React from "react";
const Thumbnail = ({ alt = "", url }) => {
  return /* @__PURE__ */ React.createElement("div", { className: "thumbnail" }, /* @__PURE__ */ React.createElement("img", { alt, src: url, className: "thumbnail__image" }));
};
export default Thumbnail;
